import React from "react";
import { FiCheck } from "react-icons/fi";

export default function Checkbox({
  checked,
  onChange,
  borderColor = "border-[#ABB2CF]",
  color = "#ABB2CF",
  boxSize = "w-4 h-4",
  iconSize = 12,
}) {
  return (
    <label className="relative inline-flex items-center cursor-pointer select-none">
      {/* Hidden native checkbox */}
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        className={`peer appearance-none  border  rounded-[2px] cursor-pointer bg-transparent   checked:bg-transparent transition-all duration-200 ${borderColor} ${boxSize}`}
      />

      {/* Custom checkmark */}
      <span
        className={`absolute inset-0 flex items-center justify-center text-white text-sm opacity-0  peer-checked:opacity-100 transition-opacity duration-200 `}
      >
        <FiCheck size={iconSize} color={color} />
      </span>
    </label>
  );
}
